<template>
  <header id="data-product-details-header" class="buying-zone__header small-12 medium-6 large-12 cell">
    <div class="flex items-center">
      <product-label-group :product="product" :base-properties="baseProperties" class="mr-1" />
      <span
        v-if="product.marketingModelYear && !product.isArchived"
        qaid="product-modelyear"
        class="text-md"
        v-html="product.marketingModelYear"
      >
      </span>
      <span
        v-if="product.modelYearIntroAndCurrent && product.isArchived"
        qaid="product-modelyear-archived"
        class="text-md"
        v-html="product.modelYearIntroAndCurrent"
      >
      </span>
    </div>
    <h1 qaid="product-name" class="buying-zone__title" v-html="product.name"></h1>
    <pdp-reviews-summary :product="product" />
    <span class="pr-separator"> / </span>
  </header>
</template>
<script>
import PdpReviewsSummary from '@/components/containers/pdp/PdpReviewsSummary';
import ProductLabelGroup from '@/components/ProductLabelGroup';

export default {
  name: 'PdpProductHeader',
  components: {ProductLabelGroup, PdpReviewsSummary},
  props: {
    product: {
      type: Object,
      required: true,
    },
    variantCode: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      required: true,
    },
  },
};
</script>
